import React, { useRef, useEffect } from 'react';
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { ModalInstall } from './ModalInstall';
import logo from '../assets/logo_final.png';

export const PreLoginWrapper = ({ children, error }) => {
    const toast = useRef(null);

    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error, life: 6000 });
        }
    }, [error]);

    return (
        <>
            <ModalInstall />
            <div className="flex flex-column align-items-center w-full" style={{ backgroundColor: 'white', minHeight: '100dvh', position: 'relative' }}>
                <div className="flex flex-column align-items-center justify-content-center w-11" style={{ maxWidth: '560px', minHeight: '100dvh' }}>
                    <Toast ref={toast} position="top-center" className="w-11" />
                <Image
                    className="pb-5"
                    src={logo}
                    alt="Vitisad"
                    imageStyle={{
                        width: '100%',
                        maxWidth: window.innerWidth < 425 ? 'min(92vw, 420px)' : '480px',
                        height: 'auto',
                    }}
                />
                {children}  {/* Aquí se renderiza el contenido adicional */}
                </div>
            </div>
            
        </>
    );
};
